export default "__VITE_ASSET__cDi1RTEM__"